import React, { useState } from 'react';
import imgbig from './images/dummy.jpg';
import imgbig1 from './images/img1.jpg';

export default function Carousel_S() {
  const images = [imgbig, imgbig1, imgbig, imgbig1, imgbig];
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="container main-crouser-container">
      <div className="row row-cols-2 main-crouser-container">
        <div className="col main-big-col">
          <img src={imgbig} alt="Main view" />
        </div>
        <div className="col main-crouser-col">
          <div className='pre-button-crouser'>
            <button onClick={prevSlide}>P</button>
            </div>
            <img
              src={images[currentIndex]}
              alt="carousel"
            />
            <div className="next-button-crouser">
            <button onClick={nextSlide}>N</button>
            </div>
          
        </div>
      </div>
    </div>
  );
}
